"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import LayoutGuester from "@/components/LayoutGuester.vue";
import PaymentOptions from "@/views/payment/views/components/PaymentOptions.vue";
import PaymentPlaformChoicesOptions from "./components/PaymentPlatformChoicesOptions.vue";
import PaymentCost from "@/views/payment/views/components/PaymentCost.vue";
import { GuesterPaymentService } from "@/guester_views/payments/services/guester-payment.service";
import { Debounce } from "vue-debounce-decorator";
import { throwErrorApi } from "@/shared/api/throw-error/throw-error.api";
let GuesterPayments = class extends Vue {
  constructor() {
    super(...arguments);
    this.guesterPaymentService = new GuesterPaymentService();
  }
  created() {
    return __async(this, null, function* () {
      try {
        this.$router.push("/auth");
      } catch (error) {
        throwErrorApi.throwError(error);
      }
    });
  }
  mounted() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  computePrice() {
    return __async(this, null, function* () {
      try {
        yield this.guesterPaymentService.computePrice();
      } catch (error) {
        throwErrorApi.printError(error);
      }
    });
  }
  buildOrder() {
    return __async(this, null, function* () {
      var _a;
      try {
        const orderInfo = yield this.guesterPaymentService.paymentService.buildOrder("proxy");
        let payment_url = (_a = orderInfo.pay) == null ? void 0 : _a.url;
        yield this.$router.push({
          path: "/orderConfirm",
          query: {
            o_no: orderInfo.orderNo,
            p_rl: payment_url
          }
        });
      } catch (error) {
        throwErrorApi.printError(error);
      }
    });
  }
};
__decorateClass([
  Debounce(800)
], GuesterPayments.prototype, "computePrice", 1);
GuesterPayments = __decorateClass([
  Component({
    components: {
      LayoutGuester,
      PaymentOptions,
      PaymentCost,
      PaymentPlaformChoicesOptions
    }
  })
], GuesterPayments);
export {
  GuesterPayments as default
};
